/**
 * THE MODULE CODES THE SCREEN SHOULD OFFER — the login token's `moduleCodes`, plus `MODIFICATIONS` for a selected correction
 * approver and for nobody else (see `core/permissions/modifications-access.ts`). Use this, not `useAuthStore(...moduleCodes)`,
 * wherever a module or a section is OFFERED, so the Modifications module cannot be visible in one place and hidden in another.
 *
 * While the approver check is loading, or if it fails, the user is treated as NOT an approver: a door that is shown late is
 * better than one shown to someone it will refuse.
 */
import { useMemo } from 'react';
import { useAuthStore } from '@store/auth.store';
import { useCorrectionWorkflowMe } from '@features/billing/hooks/useCorrectionWorkflow';
import { withModificationsAccess } from '@core/permissions/modifications-access';

export function useIsCorrectionApprover(): boolean {
  return useCorrectionWorkflowMe().data?.isApprover === true;
}

export function useEffectiveModuleCodes(): string[] {
  const moduleCodes = useAuthStore((state) => state.moduleCodes);
  const isApprover = useIsCorrectionApprover();
  return useMemo(() => withModificationsAccess(moduleCodes, isApprover), [moduleCodes, isApprover]);
}
